import React, { ReactNode } from 'react';

interface SettingsItemProps {
  icon?: ReactNode;
  title: string | ReactNode;
  subtitle?: string;
  description?: string; // 添加 description 支持
  rightElement?: ReactNode;
  onClick?: () => void;
  showChevron?: boolean;
  iconBgColor?: string;
  loading?: boolean;
}

/**
 * iOS 风格的设置项组件
 */
export const SettingsItem: React.FC<SettingsItemProps> = ({
  icon,
  title,
  subtitle,
  description,
  rightElement,
  onClick,
  showChevron = true,
  iconBgColor = 'bg-ios-gray5 dark:bg-ios-dark-gray5',
  loading = false,
}) => {
  return (
    <div
      className={`py-3 px-4 flex items-center ${onClick ? 'cursor-pointer active:bg-ios-gray6 dark:active:bg-ios-dark-gray5' : ''}`}
      onClick={onClick}
    >
      {/* 图标 */}
      {icon && (
        <div className={`w-8 h-8 rounded-ios-md ${iconBgColor} flex items-center justify-center mr-3`}>
          {icon}
        </div>
      )}

      {/* 内容 */}
      <div className="flex-1 min-w-0">
        <div className="flex items-baseline">
          <h3 className="text-ios-body font-medium">{title}</h3>
          {subtitle && (
            <p className="ml-2 text-ios-subhead text-ios-gray dark:text-ios-dark-gray truncate">
              {subtitle}
            </p>
          )}
        </div>
        {description && (
          <p className="text-ios-caption text-ios-gray dark:text-ios-dark-gray mt-1">
            {description}
          </p>
        )}
      </div>

      {/* 右侧元素 */}
      <div className="flex items-center">
        {rightElement}

        {loading ? (
          <div className="w-4 h-4 border-2 border-ios-gray3 dark:border-ios-dark-gray3 border-t-transparent rounded-full animate-spin ml-1"></div>
        ) : (
          showChevron && onClick && (
            <svg className="w-5 h-5 text-ios-gray3 dark:text-ios-dark-gray3 ml-1" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )
        )}
      </div>
    </div>
  );
};
